import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "17",
  fill: "none",
  viewBox: "0 0 15 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_4_2732)" }, [
      _createElementVNode("path", {
        fill: "#9CA3AF",
        d: "M8.656 3.156a.999.999 0 1 0-2 0v4.5h-4.5a.999.999 0 1 0 0 2h4.5v4.5a.999.999 0 1 0 2 0v-4.5h4.5a.999.999 0 1 0 0-2h-4.5v-4.5Z"
      })
    ], -1)
  ]))]))
}
export default { render: render }